import axios from "axios";
import set_tradier_account from "./../services/setTradierAccount"

export const select_tradier_account = account => dispatch => {
  set_tradier_account(account);
  dispatch({ type: "SELECT_ACCOUNT", payload: account });
};
